// extracted by mini-css-extract-plugin
export default {"rectangle":"renderer_rectangle__0okkC"};